<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <!-- <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item> -->
      </template>
      <!-- 表头设置控件 -->

      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "VehicleExpatriate",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "hirecar",
      getOptionUrl: 'addpro',
      title: "添加",
      breadcrumb: [
        { name: "承运管理", path: `/carrier/table` },
        { name: "承运商管理", path: `/carrier/table` },
        { name: "外协车辆列表" },
      ],
      formInline: {},
      viewMode: false,
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        }
      ],
      mform: {
        license: undefined,
        pcusid: undefined,
        driver: undefined,
        phone: undefined,
      },
      mrules: {
        license: [
          {
            required: true,
            validator: this.checkLicense,
            trigger: 'blur',
          }
        ],
        company: [
          {
            required: true,
            message: '请填写所属承运公司',
            trigger: 'blur',
          }
        ],
        pcusid: [
          {
            required: true,
            message: '请选择所属承运公司',
            trigger: 'blur',
          }
        ],
        driver: [
          {
            required: true,
            message: '请填写司机姓名',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
      },
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: []
        },
        {
          label: "所属承运公司",
          keyName: "company",
          err: "请选择所属承运公司",
          type: "select",
          options: [],
        },
        // {
        //   label: "承运联系人",
        //   keyName: "pcusid",
        //   err: "请选择承运联系人",
        //   type: "select",
        //   options: [],
        // },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "核定载重",
          keyName: "ton",
          err: "请填写核定载重",
          type: "number",
        },
        {
          label: "车辆照片",
          keyName: "car_image",
          type: "file",
          ptype: "car",
          tips: "最多上传10张图片",
          max: 10,
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "vtype", label: "车辆类型", minwidth: 120 },
        // { keyName: "pname", label: "承运联系人" },
        { keyName: "company", label: "所属承运公司", minwidth: 150 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "ton", label: "核定载重(吨)", minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.title = "修改外协车辆";
            this.getData(id);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      company: '',
      pcusid: '',
      baseParams: [
        // 'pcusid',
        'company',
      ],
      pcustom: [],
      detail: {},
    };
  },
  methods: {
    getid() {
      this.formInline.company = this.$route.query.company;
      this.pcusid = this.$route.query.id;
    },
    addItem() {
      this.title = '添加外协车辆'
      this.mform = {
        license: '',
        pcusid: undefined,
        driver: '',
        phone: '',
      };
      this.showDialog();
    },
    getData(id) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
        id,
      };
      this.mform['id'] = id
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.detail = { ...data }
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
              this.showDialog();
            });
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setOptions({ pcustom, car_type }) {
      this.mformCtrl.map(v => {
        if (v.keyName == 'pcusid' && pcustom && pcustom.length) {
          v.options = pcustom.map(val => {
            return {
              label: val.company,
              value: val.id,
            }
          })
        } else if (v.keyName == 'company' && pcustom && pcustom.length) {
          this.pcustom = [...pcustom]
          v.options = pcustom.map(val => {
            return {
              label: val.company,
              value: val.company,
            }
          })
        } else if (v.keyName == 'vtype' && car_type && car_type.length) {
          v.options = car_type.map(val => {
            return {
              label: val.name,
              value: val.name,
            }
          })
        }
      })
    },
    specialParamsPackage(params) {
      // console.log('params', { ...params })
      delete params['company']
      if (this.mform['company'] && this.pcustom) {
        this.pcustom.map(v => {
          if (v.company === this.mform['company']) {
            params['pcusid'] = v.id
          }
        })
      }
      if (!params['pcusid']) {
        params['pcusid'] = this.detail['pcusid']
      }
      // console.log('params', { ...params })
    },
    getList(staticfresh) {
      this.loading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      // console.log({ ...this.formInline })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        console.log(res.data, 1)
        this.tableDataHandler(res);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions();
    this.getid();
    this.getList();
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .modal-scroll {
    height: 500px;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .is-horizontal {
      display: none;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>